let port = null;
const queued = [];

export function initPredictiv() {
  window.addEventListener("message", (event) => {
    if (event.ports && event.ports[0]) {
      port = event.ports[0];
      while (queued.length) {
        port.postMessage(queued.shift());
      }
    }
  });
}

export function setValue(key, value) {
  const payload = { type: "set", key, value };
  if (port) {
    port.postMessage(payload);
  } else {
    queued.push(payload);
    window.__predictivValues = window.__predictivValues || {};
    window.__predictivValues[key] = value;
    console.log('[Predictiv setValue]', key, '=', value);
  }
}

export function closeMaterials() {
  const payload = { type: "close" };
  if (port) {
    port.postMessage(payload);
  } else {
    window.__predictivClosed = true;
    console.log('[Predictiv closeMaterials]');
  }
}
